import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { useCallback } from 'react';

export const GroupList = ({ userObj: user, roleObj: role }) => {

  const augRowsReq = useCallback((rowsReq) => {
    if (!user && !role) return;


    if (user) {
      rowsReq.query = 'USER_GROUP_DETAIL';
      rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('userId', user.id));
    }

    if (role) {
      rowsReq.query = 'ROLE_GROUP_DETAIL';
      rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('roleId', role.id));
    }

  }, [user, role])


  return (
    <EntityList
      entity="GROUP"
      augRowsReq={augRowsReq}
      augTabButtons={(buttons) => { ObjUtils.clearObj(buttons) }}
    />
  )
}